import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EGoogleEventLabel } from 'src/app/project/services/analytics/google-analytics.consts';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { TCustomFieldAccessOption, TShare } from '../../../share.model';
import { EAccessParameter } from '../access-parameters';
import { ShareEditService } from '../share-edit.service';

@Component({
    selector: 'pp-share-edit-export',
    templateUrl: './share-edit-export.component.html',
    styleUrls: ['./share-edit-export.component.scss'],
    standalone: false
})
export class ShareEditExportComponent {
  @Input() ppShare: TShare;
  @Input() ppWorkspaceId: string;
  @Output() ppChange = new EventEmitter<void>();
  @Output() ppShareChange = new EventEmitter<TShare>();

  EIconPath = EIconPath;
  EGoogleEventLabel = EGoogleEventLabel;
  accessParameters = EAccessParameter;

  constructor(private shareEditService: ShareEditService) {}

  correctProperty(
    property: EGoogleEventLabel,
    parameter?: EAccessParameter,
    field?: TCustomFieldAccessOption,
  ): void {
    this.ppShare = this.shareEditService.correctProperty({
      workspaceId: this.ppWorkspaceId,
      share: this.ppShare,
      property,
      parameter,
      field,
    });

    this.ppChange.emit();
  }
}
